import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiFileText, FiX, FiCheckCircle } = FiIcons;

const FloatingInfoWidget = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const requirements = [
    "Business name & address",
    "Federal Tax ID (EIN)",
    "Industry type",
    "Number of employees",
    "Annual revenue",
    "Coverage amounts needed"
  ];

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            transition={{ duration: 0.3 }}
            className="bg-white rounded-2xl shadow-2xl p-6 mb-4 w-80 border border-gray-200"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="bg-blue-100 w-8 h-8 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiFileText} className="text-blue-600 text-sm" />
                </div>
                <h3 className="font-bold text-gray-900">Required Info</h3>
              </div>
              <button
                onClick={toggleExpanded}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <SafeIcon icon={FiX} className="text-lg" />
              </button>
            </div>
            
            <p className="text-gray-600 text-sm mb-4">
              Have these ready for a smooth 10-minute application:
            </p>
            
            <div className="space-y-3">
              {requirements.map((req, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <SafeIcon icon={FiCheckCircle} className="text-green-600 flex-shrink-0 mt-0.5 text-sm" />
                  <span className="text-gray-700 text-sm">{req}</span>
                </div>
              ))}
            </div>
            
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-xs text-gray-500">
                💡 Tip: Having this info ready makes the process much faster!
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Button */}
      <motion.button
        onClick={toggleExpanded}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className={`flex items-center space-x-3 px-4 py-3 rounded-full shadow-lg transition-all duration-300 ${
          isExpanded 
            ? 'bg-gray-600 text-white' 
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }`}
      >
        <SafeIcon icon={FiFileText} className="text-lg" />
        {!isExpanded && (
          <span className="font-medium text-sm whitespace-nowrap">
            Required Info
          </span>
        )}
      </motion.button>
    </div>
  );
};

export default FloatingInfoWidget;